module.exports = __webpack_public_path__ + "static/media/yumbametalogo.55fc186d.svg";